import { render, staticRenderFns } from "./OnisVidaForm.vue?vue&type=template&id=30bc7e7b&"
import script from "./OnisVidaForm.vue?vue&type=script&lang=js&"
export * from "./OnisVidaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QList,QItem,QItemSection,QItemLabel})
